import { combineEpics, ofType } from "redux-observable"
import { EMPTY, catchError, concatMap, debounceTime, from, map, tap } from "rxjs"
import PricingRow from "../PricingRow"
import PricingTableRowService from "../PricingTableRowService"
import {
    ACTION_TYPES,
    deletePricingTableItemSuccess,
    patchPricingTableItemSuccess, patchPricingTablePending,
    patchPricingTableSuccess, setPricingTable, setPricingTableGroup
} from "../actions"
import { getTableId } from "../selectors"
import service from "../services/service"

const patchPricingTableItemEpic = (action$) => action$.pipe(
    ofType(ACTION_TYPES.PATCH_PRICING_TABLE_ITEM),
    debounceTime(500),
    concatMap(({payload}) => {
        return from(PricingTableRowService.updateItem(payload.id, payload.documentType, payload.itemUpdatePayload))
            .pipe(
                map(
                    (item) => {
                        if (item instanceof PricingRow) {
                            return patchPricingTableItemSuccess(item, payload.id, payload.objectId, payload.updateGroup, payload.updateTotals)
                        }
                    }
                )
            )
    })
)

const deletePricingTableItemEpic = (action$) => action$.pipe(
    ofType(ACTION_TYPES.DELETE_PRICING_TABLE_ITEM),
    concatMap(({payload}) => {
        return from(PricingTableRowService.deleteItem(payload.id, payload.documentType, payload.objectId))
            .pipe(
                map(
                    (item) => {
                        if (item instanceof PricingRow) {
                            return deletePricingTableItemSuccess(payload.id, item, payload.objectId)
                        }
                    }
                ))
    })
)

export const patchPricingTableEpic = (action$) => {
    let pendingActionsCount = 0
    return action$.pipe(
        ofType(ACTION_TYPES.PATCH_PRICING_TABLE),
        tap(() => {
            pendingActionsCount++
        }),
        concatMap(({payload}) => {
            const {documentType, documentId} = payload
            return from(service.patch(documentType, documentId, payload.payload)).pipe(
                map((res) => {
                    pendingActionsCount--
                    if (pendingActionsCount === 0) {
                        return patchPricingTableSuccess(res)
                    }
                    return patchPricingTablePending()
                }))
        }),
        catchError(() => EMPTY)
    )
}
export const createGroupEpic = (action$, state$) => action$.pipe(
    ofType(ACTION_TYPES.CREATE_GROUP),
    concatMap(({payload}) => {
        const tableId = getTableId(state$.value)
        return from(service.createGroup(tableId, payload)).pipe(
            map((res) => {
                return setPricingTableGroup(res.id, res, tableId)
            }))
    }
    )
)

export const addMultiProductFromReferenceEpic = (action$, state$) => action$.pipe(
    ofType(ACTION_TYPES.ADD_MULTI_ITEMS_FROM_REFERENCE),
    concatMap(({payload}) => {
        const tableId = getTableId(state$.value)
        return from(service.createMultiProductFromReference(tableId, payload).then(
            () => {
                return service.getTable(tableId).then((r) => {
                    if (!r.error) {
                        return setPricingTable(r)
                    }
                    return EMPTY
                })
            }
        ))
    })
)
export const bulkUpdatePricingTableEpic = (action$, state$ ) => action$.pipe(
    ofType(ACTION_TYPES.BULK_PATCH_PRICING_TABLE),
    debounceTime(500),
    concatMap(({payload}) => {
        const tableId = getTableId(state$.value)
        return from(PricingTableRowService.applyBulkUpdate(tableId, payload))
            .pipe(
                map(
                    (item) => {
                        if (item instanceof PricingRow) {
                            return patchPricingTableItemSuccess(item, payload.id, payload.objectId, payload.updateGroup, payload.updateTotals)
                        }
                    }
                )
            )
    }))

export const pricingTableItemsEpics = combineEpics(
    patchPricingTableItemEpic,
    deletePricingTableItemEpic,
    patchPricingTableEpic,
    createGroupEpic,
    addMultiProductFromReferenceEpic,
    bulkUpdatePricingTableEpic,
)



// WEBPACK FOOTER //
// ./src/state/pricing/epics/epics.ts